import React from "react";
import { Grid, Box, Typography, Button } from "@material-ui/core";
import numberWithCommas from "../../../utils/commaFunc";
import { PiCaretDownBold } from "react-icons/pi";
import { FaRegShareFromSquare } from "react-icons/fa6";
const SaleTicketList = ({ saleTickets, openMenuModal, submitMenu }) => {
  return (
    <Grid container spacing={2} justifyContent="center">
      {saleTickets.map((ticket, idx) => (
        <Grid item md={4} sm={6} xs={12} key={idx}>
          <Box className={`menu-ticket min-${ticket.minutesToSupport}`}>
            <Box className="menu-item-title">
              <div>
                <div className="min font-cur">
                  <span>サポート</span>チケット <br />
                </div>
                <div className="price font-cur">
                  <span>{numberWithCommas(ticket.price)}</span>円 （税込）
                </div>
              </div>
            </Box>
            <Box className="menu-item-box">
              <img
                src={`/images/${ticket.minutesToSupport}-min-ticket.png`}
                alt=""
              />
            </Box>
            <Typography className="mp">
              目安時間: <span>最大{ticket.minutesToSupport}</span>分
            </Typography>
            <Button
              className="menu-item-modal-trigger"
              onClick={() => {
                openMenuModal(ticket.minutesToSupport);
              }}
            >
              <FaRegShareFromSquare />
              サポートチケットで解決できるお悩みの例
            </Button>
            <button
              className="menu-btn"
              onClick={() => {
                submitMenu(ticket);
              }}
            >
              <span>チケットを購入する</span>
              <PiCaretDownBold />
            </button>
            <Typography className="menu-ticket-info">
              ※予約日時と相談員の選択画面に進みます
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default SaleTicketList;
